import { useState } from "react";
import { CameraIcon } from "@heroicons/react/24/outline";

interface ImagePreviewCellProps {
    urls: string | null;
}

export const ImagePreviewCell: React.FC<ImagePreviewCellProps> = ({ urls }) => {
    const [showAll, setShowAll] = useState(false);

    const imageUrls = urls?.split(",").filter(Boolean) || [];
    const primaryImage = imageUrls[0];

    return (
        <span
            className="flex justify-center relative"
            onMouseEnter={() => setShowAll(true)}
            onMouseLeave={() => setShowAll(false)}
        >
            {primaryImage ? (
                <img
                    className="min-w-32 w-32 h-20 object-contain"
                    src={primaryImage}
                    alt="Primary"
                    loading="lazy"
                />
            ) : (
                <CameraIcon className="w-14 text-gray-600" />
            )}

            {showAll && imageUrls.length > 1 && (
                <div className="absolute top-full mt-2 z-10 flex gap-4 max-w-xs">
                    {imageUrls.slice(1).map((url, index) => (
                        <img
                            key={index}
                            src={url}
                            alt={`Image ${index + 2}`}
                            className="h-20 object-contain p-2 bg-white rounded-md shadow animate-bounce-in"
                            loading="lazy"
                        />
                    ))}
                </div>
            )}
        </span>
    );
};
